module.exports = "/src/views/games/other/images/maps/map_3.png";